import React from 'react'
const AuthUserContext = React.createContext(null)
const UserProfileContext = React.createContext(null)
export default AuthUserContext
export { AuthUserContext, UserProfileContext }
